import { RemoteLogger } from './RemoteLogger';

/**
 * mutations
 *
 * @type {{RemoteLogger: ((function(*): Promise<*>)|*)}}
 */
export const mutations = {
  RemoteLogger,
};
